import { render, staticRenderFns } from "./item-multi-line.vue?vue&type=template&id=0ea75074&scoped=true"
import script from "./item-multi-line.vue?vue&type=script&lang=js"
export * from "./item-multi-line.vue?vue&type=script&lang=js"
import style0 from "./item-multi-line.vue?vue&type=style&index=0&id=0ea75074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea75074",
  null
  
)

export default component.exports